import React from 'react';
import {
  Placeholder,
  ComponentRendering,
  ComponentParams,
  ComponentFactory,
} from '@sitecore-jss/sitecore-jss-react';
import { Container, Grid } from '@mui/material';

export type APIComponentProps = {
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
};

export const OneColumnContentRowWithMargins = (props: APIComponentProps): React.JSX.Element => {
  return (
    <>
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div>
              <Placeholder name="column_one" rendering={props.rendering} />
            </div>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default OneColumnContentRowWithMargins;
